/**
 * Deep links into the Agenten page: `/voice-agent?section=behavior&sub=rules`.
 *
 * The assistant points owners at the exact place a setting lives. Unknown
 * values fall back to the page's defaults, they never break it.
 */
import type { AgentTab } from '../components/agents/AgentSectionCards';

/** The two tabs inside "Verhalten". */
export type BehaviorTab = 'crosssell' | 'rules';

export const AGENT_SECTIONS: readonly AgentTab[] = ['phone', 'whatsapp', 'behavior', 'limits'];
export const BEHAVIOR_TABS_IDS: readonly BehaviorTab[] = ['crosssell', 'rules'];

export const DEFAULT_AGENT_SECTION: AgentTab = 'phone';
export const DEFAULT_BEHAVIOR_TAB: BehaviorTab = 'crosssell';

/** `?section=` → the section, or null when it is missing or unknown. */
export function parseAgentSection(value: string | null): AgentTab | null {
  return AGENT_SECTIONS.find((section) => section === value) ?? null;
}

/** `?sub=` → the tab inside "Verhalten", or null when it is missing or unknown. */
export function parseBehaviorTab(value: string | null): BehaviorTab | null {
  return BEHAVIOR_TABS_IDS.find((tab) => tab === value) ?? null;
}

/**
 * The address for a section (and, inside "Verhalten", its tab): every other
 * parameter — the chosen `agent` above all — stays as it is. `sub` only
 * belongs to "Verhalten".
 */
export function agentTabUrl(href: string, section: AgentTab, behaviorTab: BehaviorTab): string {
  const url = new URL(href);
  url.searchParams.set('section', section);
  if (section === 'behavior') url.searchParams.set('sub', behaviorTab);
  else url.searchParams.delete('sub');
  return url.toString();
}
